import { render, staticRenderFns } from "./ImageActivity.vue?vue&type=template&id=6326348a&scoped=true&"
import script from "./ImageActivity.vue?vue&type=script&lang=js&"
export * from "./ImageActivity.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/style/base.css?vue&type=style&index=0&id=6326348a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6326348a",
  null
  
)

export default component.exports